"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
function ValueOrNotEntered(props) {
    return props.value || props.value === 0 ? React.createElement("span", { className: "value" }, props.value) : React.createElement("span", { className: "notentered" }, props.notEnteredText || "Not entered");
}
exports.ValueOrNotEntered = ValueOrNotEntered;
